import { render, staticRenderFns } from "./infoarchivos.vue?vue&type=template&id=5c1942ea"
import script from "./infoarchivos.vue?vue&type=script&lang=js"
export * from "./infoarchivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports